import * as Sentry from '@sentry/react'

import config from 'config'

Sentry.init({
  dsn: config.SENTRY_DSN,
  environment: config.ENV
})

export const captureException = Sentry.captureException

export const captureMessage = Sentry.captureMessage
